import { theme } from '@ketch-com/deck'
import { format, parse } from 'date-fns'
import { formatCountCopy } from 'pages/dataSentry/utils/formatCountCopy'

interface CustomTickProps {
  x?: number
  y?: number
  index?: number
  payload?: { value: string }
}

// rendering into svg so we need to use text instead of Typography :(
export const CustomDateTick = ({ x = 0, y = 0, index, payload }: CustomTickProps) => {
  const rawDate = payload?.value
  const parsedDate = rawDate ? parse(rawDate, 'yyyy-MM-dd', new Date()) : undefined
  const formatted = parsedDate ? format(parsedDate, 'MMMM do yyyy') : 'MMMM do yyyy'
  const xVal = index === 0 ? x + 40 : x

  return (
    <text
      x={xVal}
      y={y - 14}
      textAnchor="middle"
      fill={theme.palette.Text.Secondary}
      fontSize={theme.typography.footnote.fontSize}
      fontFamily={theme.typography.fontFamily}
    >
      {formatted}
    </text>
  )
}

export const CustomEventCountTicks = ({ x = 0, y = 0, payload }: CustomTickProps) => {
  const rawCount = payload?.value
  const parsedCount = rawCount ? parseInt(rawCount, 10) : undefined
  const formatted = parsedCount ? formatCountCopy(parsedCount) : '0'

  return (
    <text
      x={x + 20}
      y={y + 10}
      textAnchor="middle"
      fill={theme.palette.Text.Secondary}
      fontSize={theme.typography.footnote.fontSize}
      fontFamily={theme.typography.fontFamily}
    >
      {formatted}
    </text>
  )
}
